import { render } from "./CariAduan.vue?vue&type=template&id=10e648c8"
import script from "./CariAduan.vue?vue&type=script&lang=js"
export * from "./CariAduan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__